var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overlay",style:({
    zIndex: _setup.props.zIndex,
    backgroundColor: _setup.props.bgColor,
  }),on:{"click":_setup.click,"tap":_setup.tap}},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _setup.innerContentClick.apply(null, arguments)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }